import React, { useEffect, useState, useRef } from 'react';
import './otpInputs.scss';

const PIN_MIN_VALUE = 0;
const PIN_MAX_VALUE = 9;
const BACKSPACE_KEY = 'Backspace';

const OtpInput = ({ onChange, pinLength = 6, pinLengthProps, direction }) => {
  const [pin, setPin] = useState([]);
  const inputElement = useRef([]);

  useEffect(() => {
    inputElement.current[0]?.focus();
  }, []);

  useEffect(() => {
    const pinProps = pin.join('').length;
    pinLengthProps(pinProps);
    if (pin.join('').length === pinLength) {
      onChange(pin.join(''));
    }
  }, [pin]);

  const changePinFocus = (event, index) => {
    const ref = inputElement.current[index];
    if (ref) {
      ref.focus();
      event.preventDefault();
    }
  };

  const handleInputChange = (event, index) => {
    const { value } = event.target;
    if (Number.isFinite(Number(value))) {
      if (event.key === BACKSPACE_KEY) {
        inputElement.current[index].value = '';
        changePinFocus(event, index - 1);
        return;
      } else if (value >= PIN_MIN_VALUE || value <= PIN_MAX_VALUE) {
        let newPin = [...pin];
        newPin[index] = value.slice(-1);
        setPin(newPin);
        changePinFocus(event, index + 1);
        return;
      } else if (pin.join('').length === pinLength) {
        return;
      } else {
        let newPin = [...pin];
        newPin[index] = value;
        setPin(newPin);
        changePinFocus(event, index + 1);
      }
    }
  };

  const handleKeyDown = (event, index) => {
    if (event.key === BACKSPACE_KEY) {
      let newPin = [...pin];
      newPin[index] = '';
      setPin(newPin);
      changePinFocus(event, index - 1);
      return;
    }
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      changePinFocus(event, index + 1);
    }
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      changePinFocus(event, index - 1);
    }
  };

  const handleShowValue = (index) => {
    if (pin[index] === 0) {
      return '0';
    }
    if (!pin[index]) {
      return '';
    }
    return pin[index];
  };

  return (
    <div className="px-lg-4 px-md-3 px-sm-2 px-1">
      <section
        className={`d-flex justify-content-start ${
          direction === 'rtl' ? 'flex-row-reverse' : 'flex-row'
        }`}
      >
        {Array.from({ length: pinLength }, (_, index) => (
          <div key={`otp-input-${index}`} className="col-2 px-sm-2 px-1">
            <input
              onKeyDown={(event) => handleKeyDown(event, index)}
              onChange={(event) => handleInputChange(event, index)}
              type="number"
              label={null}
              value={handleShowValue(index)}
              ref={(el) => {
                if (el) {
                  inputElement.current[index] = el;
                }
              }}
              className={`w-100 h-100 text-center px-sm-1 pt-3 pb-1 px-1 value-style ${
                inputElement?.current?.[index]?.value === '' || pin.length === 0
                  ? 'unfill-data'
                  : 'fill-data'
              }`}
              autoComplete="off"
              tabIndex={`${index + 1}`}
            />
          </div>
        ))}
      </section>
    </div>
  );
};

export default OtpInput;
